/**
 * Berndorf — Merkliste (Wunschliste)
 *
 * Die Merkliste liegt im Browser des Besuchers (localStorage), nicht in einer
 * App. Damit funktioniert das Herz ohne Anmeldung — genau so, wie das Design
 * es zeigt: auf jeder Produktkachel, für jeden Besucher, sofort.
 *
 * ── Was hier NICHT passiert ──────────────────────────────────────────────────
 * Kein Konto, kein Server, kein zweiter Anbieter, keine personenbezogenen
 * Daten. Gespeichert werden ausschließlich Produkt-Handles. Der Preis dafür:
 * die Liste gilt je Browser, ein Gerätewechsel nimmt sie nicht mit. Der
 * Umstieg auf die kontogebundene Merkliste von Gift Reggie ändert nur diese
 * Datei — Markup, CSS und Seite bleiben (siehe Codeplan Geschenkelisten).
 *
 * ── Aufbau ───────────────────────────────────────────────────────────────────
 * - Speicher:   { "<handle>": { id, variantId, ts } }
 * - Auslöser:   [data-berndorf-wishlist-trigger]  (snippets/berndorf-wishlist-heart)
 * - Zähler:     [data-berndorf-wishlist-count]    (Kopfzeile)
 * - Seite:      [data-berndorf-wishlist-grid]     (sections/berndorf-wishlist-page)
 *
 * Klicks laufen über EINEN delegierten Listener am Dokument. Karten, die
 * nachträglich ins DOM kommen (Karussell, Section-Reload, Predictive Search),
 * funktionieren dadurch ohne erneutes Binden.
 *
 * Die Kachel auf der Merkliste-Seite wird NICHT im JS nachgebaut, sondern über
 * die Section Rendering API geholt (`/products/<handle>?section_id=
 * berndorf-wishlist-card`). Sonst gäbe es die Preislogik der Karte — kaufbare
 * Varianten, „ab“-Preis, Aktionspreis — ein zweites Mal, und sie liefe
 * auseinander.
 */
(function () {
  // Das Skript liegt global in layout/theme.liquid. Der Wächter verhindert,
  // dass ein zweiter Einbau die Klick-Listener doppelt registriert — sonst
  // merkt und entfernt ein Klick in derselben Bewegung.
  if (window.BerndorfWishlist) return;

  var STORAGE_KEY = 'berndorf.wishlist.v1';
  var LEGACY_KEY = 'bern.wishlist.items';
  var CHANGE_EVENT = 'berndorf:wishlist:change';
  var CARD_SECTION = 'berndorf-wishlist-card';

  /* ── Speicher ────────────────────────────────────────────────────────────── */

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY) || window.localStorage.getItem(LEGACY_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (err) {
      // Privater Modus oder gesperrter Speicher: Merkliste bleibt leer, das
      // Herz funktioniert weiter — es merkt sich nur nichts.
      return {};
    }
  }

  function write(store) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (err) {
      /* Speicher nicht verfügbar — bewusst still. */
    }
  }

  function count(store) {
    return Object.keys(store || read()).length;
  }

  function handlesByAge() {
    var store = read();

    return Object.keys(store).sort(function (a, b) {
      return (store[b] && store[b].ts ? store[b].ts : 0) - (store[a] && store[a].ts ? store[a].ts : 0);
    });
  }

  function announce(handle, saved) {
    document.dispatchEvent(
      new CustomEvent(CHANGE_EVENT, {
        detail: { handle: handle, saved: saved, count: count() }
      })
    );
  }

  function toggle(data) {
    var store = read();
    var saved = !store[data.handle];

    if (saved) {
      store[data.handle] = { id: data.id, variantId: data.variantId, ts: Date.now() };
    } else {
      delete store[data.handle];
    }

    write(store);
    announce(data.handle, saved);

    return saved;
  }

  function remove(handle) {
    var store = read();
    if (!store[handle]) return;

    delete store[handle];
    write(store);
    announce(handle, false);
  }

  /* ── Anstrich ────────────────────────────────────────────────────────────── */

  function paintTrigger(el, saved) {
    var label = el.querySelector('[data-berndorf-wishlist-label]');
    var text = saved ? el.getAttribute('data-label-remove') : el.getAttribute('data-label-add');

    el.setAttribute('aria-pressed', saved ? 'true' : 'false');
    el.classList.toggle('is-active', saved);
    el.removeAttribute('data-berndorf-wishlist-pending');

    if (text) {
      el.setAttribute('title', text);
      var product = el.getAttribute('data-product-title');
      el.setAttribute('aria-label', product ? text + ': ' + product : text);
    }

    if (label && text) label.textContent = text;
  }

  function paint(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var store = read();

    scope.querySelectorAll('[data-berndorf-wishlist-trigger]').forEach(function (el) {
      paintTrigger(el, Boolean(store[el.getAttribute('data-product-handle')]));
    });

    document.querySelectorAll('[data-berndorf-wishlist-count]').forEach(function (el) {
      var total = count(store);
      el.textContent = total > 99 ? '99+' : String(total);
      el.toggleAttribute('hidden', total === 0);
    });
  }

  /* ── Klicks ──────────────────────────────────────────────────────────────── */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-berndorf-wishlist-trigger]');
    if (!trigger) return;

    // Das Herz liegt auf Karten über dem Produktlink — sonst öffnet der Klick
    // die Produktseite, statt zu merken.
    event.preventDefault();
    event.stopPropagation();

    var handle = trigger.getAttribute('data-product-handle');
    if (!handle) return;

    var saved = toggle({
      handle: handle,
      id: trigger.getAttribute('data-product-id'),
      variantId: trigger.getAttribute('data-variant-id')
    });

    paintTrigger(trigger, saved);
  });

  /* ── Merkliste-Seite ─────────────────────────────────────────────────────── */

  function cardMarkup(handle) {
    return fetch(window.Shopify.routes.root + 'products/' + handle + '?section_id=' + CARD_SECTION)
      .then(function (response) {
        // 404 heißt: das Produkt gibt es nicht mehr. Dann verschwindet es auch
        // aus der Merkliste, statt jedes Mal erneut ins Leere zu laufen.
        if (!response.ok) {
          remove(handle);
          return null;
        }

        return response.text();
      })
      .then(function (html) {
        if (!html) return null;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var card = parsed.querySelector('[data-berndorf-wishlist-card]');

        // Kein Kachel-Markup = das Produkt ist gelöscht oder ausgelistet.
        // Shopify antwortet in dem Fall mit 200 und leerem `product`.
        if (!card) {
          remove(handle);
          return null;
        }

        return card;
      })
      .catch(function () {
        return null;
      });
  }

  function initPage(grid) {
    var empty = document.querySelector('[data-berndorf-wishlist-empty]');
    var loading = document.querySelector('[data-berndorf-wishlist-loading]');
    var summary = document.querySelector('[data-berndorf-wishlist-summary]');

    function setEmptyState() {
      var remaining = grid.querySelectorAll('[data-berndorf-wishlist-card]').length;

      if (empty) empty.toggleAttribute('hidden', remaining > 0);
      if (summary) {
        summary.toggleAttribute('hidden', remaining === 0);

        var one = summary.getAttribute('data-template-one');
        var many = summary.getAttribute('data-template') || '';
        var template = remaining === 1 && one ? one : many;

        summary.textContent = template.replace('{count}', String(remaining));
      }
    }

    function render() {
      var handles = handlesByAge();

      grid.innerHTML = '';

      if (!handles.length) {
        if (loading) loading.setAttribute('hidden', '');
        setEmptyState();
        return;
      }

      if (loading) loading.removeAttribute('hidden');

      Promise.all(handles.map(cardMarkup)).then(function (cards) {
        cards.forEach(function (card) {
          if (card) grid.appendChild(card);
        });

        if (loading) loading.setAttribute('hidden', '');
        paint(grid);
        setEmptyState();
      });
    }

    document.addEventListener(CHANGE_EVENT, function (event) {
      if (!event.detail || event.detail.saved) return;

      // Entfernen auf der Merkliste heißt: Kachel raus, nicht alles neu holen.
      var card = grid.querySelector('[data-berndorf-wishlist-card][data-product-handle="' + event.detail.handle + '"]');
      if (card) card.remove();

      setEmptyState();
    });

    render();
  }

  /* ── Start ───────────────────────────────────────────────────────────────── */

  function init(root) {
    paint(root);

    var grid = document.querySelector('[data-berndorf-wishlist-grid]');
    if (grid && !grid.dataset.berndorfWishlistReady) {
      grid.dataset.berndorfWishlistReady = 'true';
      initPage(grid);
    }
  }

  document.addEventListener(CHANGE_EVENT, function () {
    paint(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Die PDP tauscht bei einem Ausführungs-Wechsel ganze Sections aus
  // (assets/berndorf-product.js). Das frisch eingesetzte Herz kennt seinen
  // Zustand noch nicht — hier wird er nachgetragen.
  document.addEventListener('berndorf:section-replaced', function (event) {
    paint(event.detail && event.detail.section ? event.detail.section : document);
  });

  // Zweiter Tab, gleicher Browser: der Zähler soll nicht auseinanderlaufen.
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) paint(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.BerndorfWishlist = {
    get: read,
    paint: paint,
    has: function (handle) {
      return Boolean(read()[handle]);
    },
    count: count,
    remove: remove,
    toggle: toggle
  };
})();
